import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from 'components/Button';
import { RemoveItemModalFooter, RemoveItemModalText } from '../../../Assessment/components/EcosystemData/style';

// Remove the defaultHabitatsOptions import as it will now be passed via props

const RemoveHabitatModal = ({ closeModal, confirmRemove, item, habitatsOptions }) => {
  // Determine the appropriate level of habitats based on the item's information
  const habitats = item.Level3HabitatId
    ? habitatsOptions.level3Habitats
    : habitatsOptions.level2Habitats; // Adjust logic if level1 habitats are also possible
  const habitatItemId = item.Level3HabitatId || item.Level2HabitatId; // Include logic for Level1HabitatId if applicable

  // Find the habitat name using the ID
  const name = habitats.find((element) => element.value === habitatItemId);

  return (
    <>
      <RemoveItemModalText data-test="modal-body">
        <FormattedMessage id="removeModalText" values={{ name: <b>{name ? name.label : item.name}</b> }} />
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="destructive" onClick={confirmRemove}>
          <FormattedMessage id="yesRemove" />
        </Button>
      </RemoveItemModalFooter>
    </>
  );
};

export default RemoveHabitatModal;